import { SET_USERS_TRASH, GET_USERS_TRASH, REFRESH_USERS_TRASH } from "./types";
const initialState = {
  initialize: true,
  refresh: false,
  isRequesting: false,
  loadMore: true,
  usersTrash: [],
  limit: 10,
  page: 1,
  pages: [],
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case REFRESH_USERS_TRASH:
      return {
        ...state,
        limit: 10,
        page: 1,
        initialize: true,
        refresh: true,
        isRequesting: false,
        loadMore: true,
        usersTrash: [],
      };

    case GET_USERS_TRASH:
      return {
        ...state,
        refresh: false,
        isRequesting: true,
      };

    case SET_USERS_TRASH:
      const tempPages = [];

      if(payload.lastPage > 0 && state.lastPage != payload.lastPage) {
        for(let i = 1; i <= payload.lastPage; i++) {
          tempPages.push(i);
        }
      }

      return {
        ...state,
        isRequesting: false,
        initialize: false,
        page: payload.page,
        loadMore: payload.loadMore,
        // users: newUsers, // Use this to add more items on the current list when using a load more button or an intersection to load more items.
        usersTrash: payload.data,
        pages: tempPages.length > 0 ? tempPages : state.pages
      };

    default:
      return state;
  }
};

export default reducer;
